export default {
	state:{
       shop_name:'',
	   company_name:'',
	   shop_address:'',
	   shop_desc:'',
	   shop_beian:'',
	   kf_mobile:'',
	   search_keywords:'',
	   shop_logo:'',
	   full_name:'',
	   xh_address:'',
	   zxrx:'',
	   zhb_phone:'',
	   hyb_phone:'',
	   xzb_phone:'',
	   pxzx_phone:'',
	   xh_fax:'',
	   xh_email:'',
	   xh_longitude:'',
	   xh_latitude:'',
	   //协会证书
	   gzh_img:'',
	   gz_img:'',
	   certificate_name:'',
	   issuing_authority:'',
	   official_seal:'',
	   certificate_logo:'',
	   certificate_bg:'',
	   //上传设置
	   image_storage_type:'',
	   image_storage_params:{
		   domain:'',
		   //阿里云
		   accessKeyId:'',
		   accessKeySecret:'',
		   endpoint:'',
		   oss_bucket:'',
		   //腾讯云Cos
		   secretId:'',
		   secretKey:'',
		   region:'',
		   bucket:'',
		   //七牛云Cos
		   accessKey:'',
		   secretKey:'',
		   // region:'',
		   // bucket:'',
	   },
	   //阿里云短信
	   sms_type:'Alisms',
	   AccessKeyId:'',
	   AccessKeySecret:'',
	   aliyunsign:'',
	   TemplateCode:'',
	   //腾讯云短信
	   secretId:'',
	   secretKey:'',
	   SmsSdkAppId:'',
	   signName:'',
	   TemplateId:'',
	},
	getters:{
		getData: state => state
	},
	mutations:{
       //修改state
       editState(state,{key,val}){
       	 state[key] = val
       },
	   editParamsState(state,{name,key,val}){
	   	 state[name][key] = val
 	   },
	   initSetting(state,data){
		   data.map(v=>{
			   // 检查 v.value 是否为 null 或 undefined
			   if(v.value == null || v.value == undefined){
				   return; // 跳过空值
			   }
			   var reg = /{/g;
			   var res = v.value.match(reg);
			   if(res != null){
				   try {
					   let obj = JSON.parse(v.value)
					   for(var i in obj) {
					   		state[v.skey][i] = obj[i]
					   }
				   } catch(e) {
					   // JSON 解析失败时使用原值
					   state[v.skey] = v.value
				   }
			   }else{
				   state[v.skey] = v.value
			   }
		   })
	   }
	},
	actions:{
		
	}
}